import { createContext } from "react";

export type TUserSessionTimeoutContextType = {
  keepSessionActive: () => () => void;
};

export const UserSessionTimeoutContext = createContext<
  TUserSessionTimeoutContextType | undefined
>(undefined);
